const getters = {
  username: state => state.user.username,
  customername: state => state.user.info.customer_name,
  haslogin: state => state.user.hasLogin,
  userCode: state => state.user.userCode,
  list: state => state.app.list,
  code: state => state.app.code,
  useProduct: state => state.user.useProduct,
  productList: state => state.user.productList
};
export default getters;